module.exports = __webpack_public_path__ + "img/image_part_008.ff5ffe15.jpg";